import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { User } from '../models/user';

@Injectable()
export class HomeService {
  constructor(private http: Http) {}

  baseurl = environment.apiBaseUrl;

  userInfo: User = new User();

  // get details of logged In user
  getUser() {
    return this.http
      .post(`${this.baseurl}/user/info`, { userId: localStorage.getItem('userId') })
      .map((res: Response) => res.json());
  }

  // update user's information onchange event of fields to save into DB
  updateUser(data) {
    return this.http
      .post(`${this.baseurl}/user/update`, { userId: localStorage.getItem('userId'), data })
      .map((res: Response) => res.json());
  }

  // Record the company and project the user has currently selected.
  updateProjectDetails(data) {
    const userId = localStorage.getItem('userId');
    if (userId) {
      // The user id is required by the API, so if we don't have one, don't call the API.
      return this.http
        .post(`${this.baseurl}/user/updateProjectDetails`, { userId, data })
        .map((res: Response) => res.json());
    }
    return Observable.of({});
  }

  // this function is just replacment for local storage to save project id & company id to get details of project & company.But for now we are using local storage
  getProjectCompanyDetails() {
    return this.http
      .post(`${this.baseurl}/user/getProjectCompanyDetails`, {
        userId: localStorage.getItem('userId'),
      })
      .map((res: Response) => res.json());
  }

  // get all users to show in user management page
  getAllUsers() {
    return this.http
      .post(`${this.baseurl}/user/getAllUsers`, { token: localStorage.getItem('token') })
      .map((res: Response) => res.json());
  }

  // to get all intermath cal values from db
  getCorporateValues() {
    return this.http
      .post(`${this.baseurl}/user/getCorporateValues`, {
        projectId: localStorage.getItem('projectId'),
      })
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/home.service.ts